/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects'
import deleteUniteRegionaleActions, {
    deleteUniteRegionaleTypes,
} from '../../../redux/uniteRegionale/deleteUniteRegionale'
import { Delete } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'
import getDisabledUniteRegionalesActions from '../../../redux/uniteRegionale/getDisabledUniteRegionales'

function* deleteUniteRegionaleSagas({ response }) {
    try {
        const res = yield Delete(`uniteRegionale/${response}`)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getDisabledUniteRegionalesActions.getDisabledUniteRegionalesRequest(
                        { enable: 'true' }
                    )
                ),
                yield put(
                    deleteUniteRegionaleActions.deleteUniteRegionaleSuccess(
                        res.data.data
                    )
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
            ])
        } else {
            yield put(
                deleteUniteRegionaleActions.deleteUniteRegionaleFailure(res)
            )
        }
    } catch (error) {
        yield put(
            deleteUniteRegionaleActions.deleteUniteRegionaleFailure(error)
        )
    }
}
export function* deleteUniteRegionaleSaga() {
    yield takeLatest(
        deleteUniteRegionaleTypes.DELETE_UNITE_REGIONALE_REQUEST,
        deleteUniteRegionaleSagas
    )
}
